/**
 * @generated SignedSource<<198de1090db1eaf8fe50968b1d8880bc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Breadcrumb_data$data = ReadonlyArray<{
  readonly label: string | null | undefined;
  readonly link: string | null | undefined;
  readonly " $fragmentType": "Breadcrumb_data";
}>;
export type Breadcrumb_data$key = ReadonlyArray<{
  readonly " $data"?: Breadcrumb_data$data;
  readonly " $fragmentSpreads": FragmentRefs<"Breadcrumb_data">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "Breadcrumb_data",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "label",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "link",
      "storageKey": null
    }
  ],
  "type": "Breadcrumb",
  "abstractKey": null
};

(node as any).hash = "d9be4f32addd6c41aa068ce855bb6747";

export default node;
